import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ModelListWithCursor } from '../../../commons/angular/models/model-list-with-cursor.model';
import { AuditLogEntry } from '../../../commons/angular/services/audit-log-parser.service';

@Injectable({ providedIn: 'root' })
export class ActionRecordsHttpService {
  private base_url = '/action-records';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  getActionRecords(params: {
    actions?: string;
    domains?: string;
    status?: string;
    actorType?: string;
    actorId?: string;
    from?: number;
    to?: number;
    limit?: number;
    cursor?: string;
  }): Observable<ModelListWithCursor<AuditLogEntry>> {
    return this.http.get<ModelListWithCursor<AuditLogEntry>>(this.base_url, { params });
  }
}
